import React from 'react';
import TextField from '../../FormField/TextField';
import { DESTROY, NUMBER_PATTERN } from '../../variables';
import type { QuestionProps } from '../Question';

//TODO: Support multiple mode
const TextQuestion = ({
  answerItems = [],
  answerItem = {},
  inputType,
  placeholder,
  helperText,
  isRequired,
  allowMultiple,
  onChange,
  readOnly = false,
  shrink = false,
}: QuestionProps) => {
  const [value, setValue] = React.useState(answerItem.value);

  return (
    <TextField
      multiline={inputType !== 'number'}
      fullWidth
      disableEnter={inputType === 'string'}
      value={value}
      placeholder={placeholder}
      helperText={helperText}
      required={isRequired}
      InputProps={{ readOnly }}
      size="small"
      onChange={(event, valid) => {
        setValue(event.target.value);
        onChange?.(
          {
            answerItem: {
              ...answerItem,
              value: event.target.value,
              ...(!!answerItem.id && {
                [DESTROY]: !isRequired && !event.target.value,
              }),
            },
            valid,
          },
          'single',
        );
      }}
      {...(inputType === 'number' && {
        type: 'number',
        inputMode: 'numeric',
        inputProps: { min: 0, pattern: NUMBER_PATTERN },
      })}
      {...(shrink && { InputLabelProps: { shrink } })}
    />
  );
};

export default TextQuestion;
